module.exports = __webpack_public_path__ + "static/img/4.e0c0742.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/9/eng/4.png
// module id = bA3h
// module chunks = 0